import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { FetchContext } from 'context/FetchContext';

function useManageStream() {
  const queryClient = useQueryClient();
  const navigate = useHistory();
  const { privateFetch } = useContext(FetchContext);

  async function manageStream(data) {
    if (data.id) {
      // Update
      return privateFetch.put(`/v1/admin/streams/${data.id}`, {
        name: data.name,
        status: data.status,
      });
    }
    // Create
    return privateFetch.post('/v1/admin/streams', { name: data.name, status: data.status });
  }

  return useMutation(manageStream, {
    onSuccess(response) {
      // Optionally use response.data to update local state
      queryClient.invalidateQueries('streams-list');
      navigate.push('/manage/stream'); // Go back
    },
  });
}

export default useManageStream;
